<div class="header">
    <h2 mat-dialog-title i18n>{{ 'EDIT STATE' }}</h2>
    <div *ngIf="item" class="text-muted">ID: {{ item.id }}</div>
</div>
<mat-dialog-content>
<form [formGroup]="form">
    <fieldset>
        <fui-fieldset-legend label="State details" i18n-label>
        </fui-fieldset-legend>

        <mat-form-field appearance="outline">
            <mat-label i18n>State name</mat-label>
            <input matInput type="text" formControlName="name" readonly>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label i18n>Role(s) who can delete booking</mat-label>
            <mat-select formControlName="canDeleteRoles" [compareWith]="compareOptionsByID" multiple>
                <mat-optgroup *ngFor="let group of availableRoles" [label]="group.name">
                    <mat-option *ngFor="let role of group.items" [value]="role" [title]="role.name">{{ role.name }}</mat-option>
                </mat-optgroup>
            </mat-select>
            <mat-hint i18n>Which role(s) can completely delete booking in this state?</mat-hint>
        </mat-form-field>
    </fieldset>
</form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <!--
    <div>
        <button i18n
                mat-flat-button
                color="warn"
                (click)="onDelete()"
                tabindex="-1">Delete state</button>
        <p i18n class="text-muted small">
            Deleting the states removes it completely from the workflow.
            This will also remove relevant Transitions and Permissions.
        </p>
    </div>
    -->
    <button i18n mat-button
            (click)="onCancel()"
            tabindex="-1">Discard</button>
    <button i18n
            type="submit"
            mat-flat-button
            color="primary"
            (click)="onSave()"
            [disabled]="!form.valid">Apply</button>
</mat-dialog-actions>
